export enum HostedPaymentFieldErrors {
    EXPIRED_TOKEN = 'EXPIRED_TOKEN',
    TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND',
    NO_PAYMENT_DETAILS_LINKED_TO_TOKEN = 'NO_PAYMENT_DETAILS_LINKED_TO_TOKEN'
}
